import Page from './containers/Page';

export default Page;
